module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2VvrrGXMaI06IkcEMWcQu6-a6522c3a7f837ca5cc135a2035b0ad0b.jpg";